export enum LegalInfoType {
    CookiePolicy = 'CookiePolicy',
    LegalInfo = 'LegalInfo',
    AppInfo = 'AppInfo',
}
